import { BoxContainer, PrimaryButton, ReactIcons } from "@kalyzee/kalyzee-ui";
import React from "react";

import workBoxStyles from "./WorkBox.module.css";

export interface MediaSourceWorkBoxProps {
  children: React.ReactNode;
  title?: string;
  footer?: React.ReactNode;
  onClose?: () => void;
  style?: React.CSSProperties;
  className?: string;
}

export const MediaSourceWorkBox: React.FC<MediaSourceWorkBoxProps> = ({
  children,
  title = "Sources",
  footer,
  onClose,
  style,
  className,
}) => {
  return (
    <div style={{ width: "100%", flex: 1, minHeight: 0, display: "flex", flexDirection: "column", ...style }} className={className}>
      <BoxContainer
        style={{ width: "100%", flex: 1, minHeight: 0 }}
        topBarProps={{
          left: [
            <ReactIcons.PlayScreens style={{ width: "1.5em", height: "1.5em" }} />,
          ],
          center: [
            <span className={workBoxStyles.label}>{title}</span>,
          ],
          right: onClose ? [
            <PrimaryButton onClick={onClose}>
              <ReactIcons.Close style={{ height: "0.8em" }} />
            </PrimaryButton>,
          ] : [],
        }}
      >
        {children}
      </BoxContainer>
      {footer}
    </div>
  );
};
